**Sortino** measures the performance of the index adjusted for downside risk,
through differentiating downside volatility from total volatility.
